import * as Yup from "yup";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import CustomAlert from "../../components/CustomAlert";

import dayjs from "dayjs";
import { fetchDiplomaKinds } from "../../../services/diplomaKindService";
import { updateSailor } from "../../../services/sailorService";
import useLocale from "../../../hooks/useLocale";
import GovGrModal from "../../../components/GovGrModal";
import GovGrTextField from "../../../components/GovGrTextField";
import GovGrSelectBox from "../../../components/GovGrSelectBox";
import { FIELD_IS_REQUIRED } from "../../../constants";
import GovGrDate from "../../../components/GovGrDate";
import GovGrButton from "../../../components/GovGrButton";

function UpdateDialog({ open, close, refetch, selectedItem }) {
  const { t } = useLocale();
  const [error, setError] = useState("");

  // Mutation for creating data
  const { mutate } = useMutation(updateSailor, {
    onSuccess: (data) => {
      refetch();
      close();
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const { data: diplomaKinds } = useQuery("diplomaKinds", fetchDiplomaKinds);

  // Initial values
  const initialValues = {
    id: selectedItem.s_id,
    ameth: selectedItem.s_ameth || "",
    first_name: selectedItem.s_first_name || "",
    last_name: selectedItem.s_last_name || "",
    f_name: selectedItem.s_f_name || "",
    m_name: selectedItem.s_m_name || "",
    birth_date: new Date(selectedItem.s_birth_date) || null,
    ani: selectedItem.s_ani || null,
    diploma: selectedItem.diploma,
  };

  const sailorFormValidation = Yup.object().shape({
    ameth: Yup.string().required(t("Field is required")),
    first_name: Yup.string().required(t("Field is required")),
    last_name: Yup.string().required(t("Field is required")),
    f_name: Yup.string().required(t("Field is required")),
    m_name: Yup.string().required(t("Field is required")),
    ani: Yup.string().required(t("Field is required")),
    birth_date: Yup.date().nullable().required(t("Field is required")),
    diploma: Yup.object().required(t(FIELD_IS_REQUIRED)).nullable(),
  });

  const handleUpdatedItem = (values) => {
    mutate({ id: selectedItem.id, ...values });
  };

  return (
    <>
      <GovGrModal
        open={open}
        onClose={close}
        aria-labelledby="form-dialog-title"
        customContent={true}
      >
        <div className="govgr-heading-l m-0">{t("Update Sailor Details")}</div>

        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />
        <Formik
          initialValues={initialValues}
          validationSchema={sailorFormValidation}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            const { birth_date, diploma, ...rest } = values;

            const createData = {
              ...rest,
              diploma_id: diploma?.id,
              birth_date: dayjs(birth_date).format("YYYY-MM-DD"),
            };

            handleUpdatedItem(createData);
            setSubmitting(false);
          }}
        >
          {({ submitForm }) => (
            <Form>
              <DialogContent>
                <Grid container direction="column">
                  <GovGrTextField name="ameth" type="text" label={t("Ameth")} />
                  <Grid container direction="row" spacing={4}>
                    <Grid item xs={6}>
                      <GovGrTextField
                        name="first_name"
                        label={t("First Name")}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <GovGrTextField name="last_name" label={t("Last Name")} />
                    </Grid>
                  </Grid>
                  <Grid container direction="row" spacing={4}>
                    <Grid item xs={6}>
                      <GovGrTextField name="f_name" label={t("Father Name")} />
                    </Grid>
                    <Grid item xs={6}>
                      <GovGrTextField name="m_name" label={t("Mother Name")} />
                    </Grid>
                  </Grid>
                  <GovGrDate name="birth_date" label={t("Birth Date")} />
                  <GovGrTextField name="ani" type="text" label={t("ANI")} />
                  <GovGrSelectBox
                    name="diploma"
                    label={t("Diploma Kind")}
                    options={diplomaKinds || []}
                    optionlabel="name"
                    defaultoptiontext={t("Choose Here")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              </DialogContent>
              <DialogActions>
                <GovGrButton
                  onClick={submitForm}
                  variant="primary"
                  buttonText={t("Submit")}
                />
                <GovGrButton
                  onClick={submitForm}
                  variant="secondary"
                  buttonText={t("Cancel")}
                />
              </DialogActions>
            </Form>
          )}
        </Formik>
      </GovGrModal>
    </>
  );
}

export default UpdateDialog;
